// extracted by mini-css-extract-plugin
export const grid = "article-preview-grid-module--grid--q2P_G";